<template>
  <div class="footer_m">
      <div class="footer__margin">
          <div class="footer__margin__l">
              <div class="footer__margin__l_bl">
                <p>
                    © 2019 - {{year}}
                </p>
              </div>
              <div class="footer__margin__l_bl">
                    <router-link tag="a" to="/policy">политика конфиденциальности</router-link>
              </div>
              
          </div>
          <div class="footer__margin__c">
              <p><span class="mdi mdi-phone"></span> +7(707) 304 92 33</p>
          </div>
          <div class="footer__margin__r">
              <div class="footer__pay__title">
                    <p>
                        Способы оплат
                    </p>
              </div>
              <div class="footer__pays">
                  <img src="../assets/pay2.png" alt="">
              </div>
          </div>
      </div>
      <div class="footer_dev">
          <a href="https://upmarketing.kz" target="_blank">разработано upmarketing.kz</a>
      </div>
  </div>
</template>

<script>

export default {
  name: 'footer_m',
  data() {
      return {
          year: ''
      }
  },
  components: {
  },
  methods: {
     getYear() {
          let getY = new Date()
          let y = getY.getFullYear()
          this.year = y
      }
  },
  mounted() {
      this.getYear()
  }
}
</script>
<style scoped lang="less">
@baseMedia: 900px;

.footer_m {
    width: 100%;
    background: #494948;
    padding-top: 20px;
    padding-bottom: 20px;
    border-top: 3px dotted #ccc; 
    .footer_dev {
        width: 100%;
        padding-top: 10px;
        padding-bottom: 10px;
        text-align: center;
        a {
            color: #ffffff;
            text-transform: uppercase;
            font-size: 12px;
        }
    }
    .footer__margin {
        width: 1200px;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        @media (max-width: @baseMedia) {
            width: 95%;
            flex-wrap: wrap;
            justify-content: flex-start;
        }
        .footer__margin__l {
            width: 33%;
            @media (max-width: @baseMedia) {
                width: 100%;
            }
            .footer__margin__l_bl {
                width: 100%;
                margin-bottom: 10px;
                p {
                    color: #fff;
                    font-size: 20px;
                    @media (max-width: @baseMedia) {
                        font-size: 17px;
                    }
                }
                a {
                    color: #fffff9;
                    font-size: 17px;
                }
            }
            
        }
        .footer__margin__c {
            width: 33%;
            display: flex;
            justify-content: center;
            @media (max-width: @baseMedia) {
                width: 100%;
                justify-content: flex-start;
                margin-top: 10px;
            }
            p {
                color: #fff;
                font-size: 20px;
                @media (max-width: @baseMedia) {
                    font-size: 17px;
                }
            }
            span {
                color: #fff;
                margin-right: 5px;
                @media (max-width: @baseMedia) {
                    font-size: 17px;
                }
            }
        }
        .footer__margin__r {
            width: 33%;
            display: flex;
            align-items: flex-end;
            flex-direction: column;
            @media (max-width: @baseMedia) {
                width: 100%;
                flex-direction: row;
                justify-content: flex-start;
                margin-top: 10px;
                flex-wrap: wrap;
            }
            .footer__pay__title {
                width: 100%;
                text-align: right;
                @media (max-width: @baseMedia) {
                    text-align: left;
                }
                p {
                    color: #fff;
                    font-size: 20px;
                    @media (max-width: @baseMedia) {
                        font-size: 17px;
                    }
                }
            }
            .footer__pays {
                width: 100%;
                text-align: right;
                margin-top: 10px;
                img {
                    width: 129px;
                }
                @media (max-width: @baseMedia) {
                    text-align: left;
                }
            }
        }
    }
}
</style>